import React from "react";
import { flex1 } from "styles/sx";
import { NorreLoading } from "components/common/loading/NorreLoading";

export const PublicPageLoading = () => {
    return <NorreLoading sx={flex1} />;
};
